/* eslint-disable */
import React, { FC, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import withLocalization from '../hoc/withLocalization';
import packageOverviewIcon from '../../features/siteTheme/Brands/tmvcs/logo/tmvc-pkg-icon.svg';
import { RootState } from '../../redux/rootReducer';
import ImgGalleryModal from '../Modal/ImgGalleryModal/ImgGalleryModal';
import InformationSummary from './InformationSummary';
import ParticipationDetails from '../ParticipationDetails/ParticipationDetails';
import { refinePackageData } from '../../util/packagingOverviewMapping';
import { replacePlaceholder } from '../../util/CommonLogic';
import isAsia from '../../util/isAsia';
import './OrderSummaryDetails.scss';

interface SearchPanelProps {
  localize?: any;
  history: any;
}
const OrderSummaryDetails: FC<SearchPanelProps> = (props: SearchPanelProps) => {
  const { localize } = props;

  const offerDetails: any = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  const prospectDetails: any = useSelector((state: RootState) => state.offerDetails.prospect);
  const refineData: any = (offerDetails?.offers && offerDetails?.offers[0]) || '';
  const tourType = refineData?.tourTp || '';
  const isTr: boolean = tourType && tourType.toUpperCase() === 'TR' ? true : false;
  const packageData = refinePackageData(refineData);
  const [modalOpen, setModalOpen] = useState(false);

  const [participationModalOpen, setParticipationModalOpen] = useState(false);

  const roomTypeData = (refineData?.roomTypes && refineData?.roomTypes[0]) || '';
  const imgData = (roomTypeData?.property?.imgList4 && roomTypeData?.property?.imgList4[0]) || '';
  const heroImgObj: any = (imgData && imgData['4:3']) || {};
  const path = heroImgObj?.path || imgData?.path || '';
  //const path = heroImg?.path || '';
  const imgDataArr = roomTypeData?.imgList16?.extImages || [];
  const intImgDataArr = roomTypeData?.imgList16?.intImages || [];
  const showGallery = imgDataArr.length > 0 || intImgDataArr > 0 ? true : false;

  /*const callCenterCode = prospectDetails?.callCenterCode || '';
  const jahiaKey = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.chat-link`;
  const jahiaCallcenter = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.activationPhone`;
  const callCenterPhoneWithCode = localize(jahiaCallcenter);*/

  const openParticipationModal = () => {
    setParticipationModalOpen(true);
  };
  const closeModal = () => {
    setParticipationModalOpen(false);
  };
  const openModal = () => {
    setModalOpen(true);
  };

  const closeGallaryModal = () => {
    setModalOpen(false);
  };
  const handleKeyDown = () => {};
  const viewResortDetails = () => {
    const roomType = (refineData?.roomTypes && refineData?.roomTypes[0]) || '';
    const marsha_code = roomType?.property?.marshaCode || 0;
    const hotelFlag = roomType?.property?.isHotel || '';
    const isHotel = hotelFlag?.toUpperCase() === 'Y' ? true : false;
    const hotelJahiaText = localize('preview-sales-engine.static-content.copy.pbeo.view-hotel-url');
    const resortJahiaText = localize('preview-sales-engine.static-content.copy.pbeo.view-resort-url');
    const hotelLink = replacePlaceholder(hotelJahiaText, '{marshaCode}', marsha_code);
    const resortLink = replacePlaceholder(resortJahiaText, '{marsha_Code}', marsha_code);
    const resortUrl = isHotel ? hotelLink : resortLink;

    /*const resortUrl = isHotel
      ? `https://www.marriottvacationclubs.com/s/${marsha_code}`
      : `https://www.marriott.com/${marsha_code}`;*/
    //const resortUrl = replacePlaceholder(linkText, '{days}', orderInfo?.days);
    window.open(resortUrl);
  };
  const tnrDisclaimer = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-overview-disclaimer-tnr')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-surcharge-disclaimer-tnr');
  const trDisclaimer = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-overview-disclaimer')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-surcharge-disclaimer');
  return (
    <>
      {participationModalOpen && <ParticipationDetails closeModal={closeModal} />}
      {modalOpen && <ImgGalleryModal closeModal={closeGallaryModal} />}
      <div className="orderSummary-container">
        <div className="innerOrderSummaryContainer">
          <div className="inner-orderSummary-title-container">
            <span className="orderSummary-title-wrapper">
              {localize('preview-sales-engine.static-content.copy.pbeo.intl.purchase-summary-title')}
            </span>
          </div>
          <div className="packageOffer-intl-CardContainer">
            <div className="summary-resortInfo-container">
              <div className="resortInfo_img-container">
                <img src={path} alt={'hero-image'} className="thumbnail-package-overview" />
                {showGallery && (
                  <div className="Pkg-icon-container">
                    <input
                      type="image"
                      src={packageOverviewIcon}
                      alt={'gallary-icon'}
                      className="pkg-overview-icon"
                      onClick={() => openModal()}
                      arial-label={'image-galarry-detail'}
                    />
                  </div>
                )}
              </div>
              <div className="summary-resortInfo_desc-container">
                <span className="orderSummary-dsc-name-wrapper">{`${packageData?.name}`}</span>
                <div
                  className="desc-resort-detail-link"
                  onClick={viewResortDetails}
                  onKeyDown={handleKeyDown}
                  arial-label={'view-resort-detail'}
                  tabIndex={0}
                >
                  {localize('preview-sales-engine.static-content.copy.pbeo.view-resort-details-link-label')}
                </div>
              </div>
            </div>
          </div>
          <div className="orderSummary-content-section">
            <InformationSummary />
            {isTr ? (
              <div
                className="summary-tax-info-span"
                dangerouslySetInnerHTML={{
                  __html: trDisclaimer,
                }}
              ></div>
            ) : (
              <div
                className="summary-tax-info-span"
                dangerouslySetInnerHTML={{
                  __html: tnrDisclaimer,
                }}
              ></div>
            )}
            {/*<div className="orderSummaryDiveder"></div>*/}
            <div className="summaryBodyLinkContainer">
              <button className="summaryBodyLinkText" onClick={() => openParticipationModal()}>
                {localize('preview-sales-engine.static-content.copy.pbeo.intl.intl-terms-and-conditions-label')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default withLocalization(OrderSummaryDetails);
